<template>
  <layout>
    <page-header :header="$t('import_entities.title')" />
    <div class="content">
      <b-card>
        <resource-form @saved="returnBack" @cancelled="returnBack" />
      </b-card>
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

export default {
  name: 'ImportEntitiesCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `import_entities` })
    },
  },
}
</script>
